import { fetchAuthSession } from '@aws-amplify/auth';

export const pollTokenRefresh = async (maxRetries = 20, delayMs = 2000) => {

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
            const { tokens } = await fetchAuthSession({ forceRefresh: true });
            const companyId = tokens?.idToken?.payload?.['custom:companyId'];

            if (companyId) {
                return {
                    success: true,
                    tokens,
                    companyId,
                };
            }

            if (attempt < maxRetries) {
                await new Promise(resolve => setTimeout(resolve, delayMs));
            }
        } catch (error) {
            if (attempt === maxRetries) {
                return {
                    success: false,
                    tokens: null,
                    companyId: null,
                };
            }
            await new Promise(resolve => setTimeout(resolve, delayMs));
        }
    }

    return {
        success: false,
        tokens: null,
        companyId: null,
    };
};
